(function($) {
$(document).ready(function() {
  $(window).scroll(function() {
    $("body .bodytest .two-col-cta .promo-wrap").each(function(i) {
      var bottom_of_element = $(this).offset().top + $(this).outerHeight();
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      if (bottom_of_window > bottom_of_element) {
        $(this).animate({ opacity: "1", "margin-right": "0px" }, 1000);
      }
    });
  });

  if ($("html").hasClass("ua-ie")) {
    $(
      ".mn-refresh .two-col-cta .card-wrap .card-right .img-wrap"
    ).imageResponsiveIe();
  }
});
})(jQuery);
